import * as React from "react"

import { cn } from "@/lib/utils"

function Input({ className, type, ...props }: React.ComponentProps<"input">) {
  return (
    <input
      type={type}
      data-slot="input"
      className={cn(
        // Base styles
        "file:text-foreground placeholder:text-muted-foreground selection:bg-primary selection:text-primary-foreground",
        "border-input h-9 w-full min-w-0 rounded-md border bg-transparent px-3 py-1 text-base shadow-xs outline-none",
        "file:inline-flex file:h-7 file:border-0 file:bg-transparent file:text-sm file:font-medium",
        "md:text-sm",
        // Transitions
        "transition-all duration-200 ease-out",
        // Dark mode
        "dark:bg-input/30",
        // Hover state
        "hover:border-muted-foreground/40",
        // Focus state - enhanced with primary color and glow
        "focus-visible:border-primary focus-visible:ring-[3px] focus-visible:ring-primary/20",
        // Error state - with subtle background tint
        "aria-invalid:border-destructive aria-invalid:ring-[3px] aria-invalid:ring-destructive/20 aria-invalid:bg-destructive/5",
        "dark:aria-invalid:ring-destructive/30 dark:aria-invalid:bg-destructive/10",
        // Success state for validated inputs
        "aria-[describedby*=success]:border-success aria-[describedby*=success]:ring-[3px] aria-[describedby*=success]:ring-success/20",
        // Disabled state
        "disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50",
        className
      )}
      {...props}
    />
  )
}

export { Input }
